import BaseView from "./utilities/baseView.js";
import Search from "./modules/ApartmentSearch/search.js";
import SearchFilters from "./modules/SearchFilters/index.js";
import SliderCounter from "./utilities/slider-counter.js";
import Selectpicker from "./utilities/selectpicker.js";
import Gallery from "./utilities/gallery.js";
import { tns } from "./../../../node_modules/tiny-slider/src/tiny-slider";
import ImgLazyLoader from "./utilities/imgLazyLoader.js";
import ImagesSliderModule from './modules/Apartment/imagesSliderModule.js';
import "leaflet";

class WithoutDateView extends BaseView {
    sliders = document.querySelectorAll(".apartment-slider");
    gallery = null;
    imagesSliderModule = null;
    search = null;
    sliderCounter = null;

    constructor() {
        super(apartmentWithoutDateConfig);
        new Selectpicker();
        apartmentSearchConfig["settings"]["regionId"] = apartmentWithoutDateConfig["settings"]["regionId"];
        apartmentSearchConfig["settings"]["cityId"] = apartmentWithoutDateConfig["settings"]["cityId"];
        apartmentSearchConfig["settings"]["facilityId"] = apartmentWithoutDateConfig["settings"]["facilityId"];
        this.search = new Search(
            apartmentSearchConfig,
            this.notification,
            this.loader,
            true,
            false
        );
        this.sliderCounter = new SliderCounter();
        this.gallery = new Gallery(this.settings("gallery"));
        this.imagesSliderModule = new ImagesSliderModule(this.gallery);
        this.preparePhotosSliders();
        this.bindToggleIconsButton();
    }

    preparePhotosSliders = () => {
        this.sliders.forEach((slider) => {
            const tinySLider = tns({
                preventScrollOnTouch: "force",
                container: slider,
                items: 1,
                nav: false,
                mouseDrag: true,
                center: false,
                controls: true,
                swipeAngle: false,
                arrowKeys: true,
            });

            if (tinySLider !== undefined) {
                tinySLider.events.on("indexChanged", (data, eventName) => {
                    this.sliderCounter.add(data);
                });
            }
        });
    };

    bindToggleIconsButton = () => {
        const iconsContainers = document.querySelectorAll('.apartment-description-list__icons');

        iconsContainers.forEach(iconsContainer => {
            const button = iconsContainer.parentElement.querySelector('.apartment-description-list__toggle');
            if (iconsContainer.childElementCount <= 3) {
                button.remove();
            } else {
                button.addEventListener('click', () => {
                    button.classList.toggle('open');
                    iconsContainer.classList.toggle('open');
                });
            }
        });
    }
}

new WithoutDateView();